import { useGetters } from 'vuex-composition-helpers'
import type { MultiselectOption } from '@ironsight/types'
import { computed, Ref } from 'vue'

export function useResourceTypeJobFilter(): {
  options: Ref<MultiselectOption[]>
} {
  const { getAllResourceTypes } = useGetters('resourceTypes', ['getAllResourceTypes'])

  const options = computed<MultiselectOption[]>(() =>
    getAllResourceTypes.value
      .map((rt) => ({ label: rt.name, value: rt.id }))
      .sort((a, b) => a.label.localeCompare(b.label)),
  )

  return { options }
}
